import './brand/colors.scss'
import './brand/typography.scss'
import './Application.scss'

import React, { Fragment } from 'react'
import { Route, Switch } from 'react-router-dom'

import GestureHandler from './components/GestureHandler/GestureHandler'
import LoginOverrideView from './views/LoginOverrideView'
import LoginView from './views/LoginView'
import MainSideBar from './modules/MainSideBar/MainSideBar'
import NotFoundView from './views/NotFoundView'
import OldCMView from './views/OldCMView'
import OldMainSideBar from './modules/OldMainSideBar/OldMainSideBar'
import SignupView from './views/SignupView'
import SoccerView from './views/Soccer/SoccerView'
import TopBar from './modules/TopBar/TopBar'
import WelcomeView from './views/WelcomeView'
import { useIsLogged } from './hooks'
import { useSelector } from 'react-redux'

function Application() {
  const logged = useIsLogged()

  return (
    <GestureHandler>
      <div className="application">
        { logged ? <AuthorizedUserView/> : <UnauthorizedUserView/> }
      </div>
    </GestureHandler>
  )
}

const UnauthorizedUserView = () => {
  return (
    <Switch>
      <Route exact path="/login/override/:email">
        <LoginOverrideView/>
      </Route>
      <Route exact path="/login">
        <LoginView/>
      </Route>
      <Route exact path="/signup">
        <SignupView/>
      </Route>
      <Route>
        <LoginView/>
      </Route>
    </Switch>
  )
}

const AuthorizedUserView = () => {
  const profile = useSelector(state => state.profile)

  return (
    <Fragment>
      <TopBar />
      <div className="application-content">
        <Switch>
          {profile.products.SOCCER &&
            <Route path="/soccer/">
              <MainSideBar />
              <SoccerView/>
            </Route>
          }
          {(profile.products.OLD_CM || profile.products.OLD_DELEGATE) &&
            <Route path="/cm/">
              <OldMainSideBar />
              <OldCMView />
            </Route>
          }
          <Route path="/">
            <WelcomeView/>
          </Route>
          <Route>
            <NotFoundView/>
          </Route>
        </Switch>
      </div>
    </Fragment>
  )
}

export default Application
